import { spLogTags } from "@eventr/common";
import { useConnectivityStore } from "../../feat/connectivity/connectivity.store";
import { bs } from "../bound.store";
import { getLiveToken } from "../rocketchatState/rocketchatUi.store";

export interface WebsocketOpenCheck {
  canOpen: boolean;
  /** True when the block clears on its own, so a backoff retry is worth scheduling. */
  retryable: boolean;
  reason: string;
}

export function canOpenWebsocket(isActivated: boolean): WebsocketOpenCheck {
  // Only ever called from zustand actions (openWebsocket), never during a render, so this
  // stays a plain function and a non-reactive read — the signal read here was untracked too.
  const liveToken = getLiveToken();
  if (
    isActivated &&
    bs().selectedOrg &&
    useConnectivityStore.getState().isConnectivityAvailable &&
    liveToken &&
    liveToken.authToken &&
    liveToken.org === bs().selectedOrg?.name
  ) {
    spLogTags("Have a valid RocketChat token for org: " + liveToken.org, ["rocketchat"]);
    return { canOpen: true, retryable: false, reason: "" };
  }

  const blocked = (reason: string, retryable: boolean): WebsocketOpenCheck => {
    spLogTags("Cannot open websocket: " + reason, ["rocketchat"]);
    return { canOpen: false, retryable, reason };
  };

  if (!isActivated) {
    return blocked("Rocketchat is not active", false);
  }
  if (!bs().selectedOrg) {
    return blocked("No selected org", false);
  }
  if (!useConnectivityStore.getState().isConnectivityAvailable) {
    return blocked("No connection available", true);
  }
  if (!liveToken || !liveToken.authToken) {
    return blocked("No valid tokens", true);
  }
  if (liveToken.org !== bs().selectedOrg?.name) {
    return blocked("No valid token for this org", true);
  }
  return blocked("Unknown issue", true);
}
